import {useMemo} from 'react'
import {useSelector} from '../../../store.js'
import ConfigSelect from './ConfigSelect.js'
import {
  labelShippersSelector,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import {
  SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'
import {SHIPPER_VENDORS} from '../../../common/constants/ShipperNames.js'
import useStable from '../../../common/useStable.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {usePresetMultiShipperSelector} from '../../../data/company.js'
import {getValidShippingMethodOptions} from './ShippingMethodFilter.js'

function labelPropertiesFunc(shipperType) {
  return [`${shipperType}__shipping_method`]
}

export default function ShippingMethod() {
  const {labelInfoID, shipperType, isLabelEnableMode} = useLabelConfigContext()
  const propertySpecs = ShippingMethod.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const shippers = useStable(
    useSelector((state) => labelShippersSelector(state, {labelInfoID})),
  )
  const usePresetMultiShipper = useSelector(usePresetMultiShipperSelector)

  const options = useMemo(
    () => getValidShippingMethodOptions(labelInfoID),
    [labelInfoID, shippers],
  )

  if (!isLabelEnableMode || usePresetMultiShipper) {
    // rate dropdown is outside of presets
    return null
  }

  return (
    <ConfigSelect
      label="Shipping Method"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      options={options}
    />
  )
}

ShippingMethod.propertySpecList = [
  {
    validShipperTypes: SHIPPER_VENDORS,
    labelPropertiesFunc: labelPropertiesFunc,
    dependentPropertiesFunc: SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
